import {
    getLanguage,
    LEGAL_NAME,
    LOGIN,
    USER_ID,
} from "../../source/js/common";
import axios from 'axios'
import cookie from "react-cookies";
import {Modal} from 'antd';
const commonLan = require('../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

let overTime = ()=>{
    var lastTime = new Date().getTime();
    var currentTime = new Date().getTime();
    var timeOut = 30 * 60 * 1000
    axios.get("aisino/portalIndex/getSessionTimeout").then(res=>{
        timeOut = res * 60 * 1000; //设置超时时间： 分
    })
    /* 鼠标点击页面更新时间 */
    // document.body.onclick = function(ev){
    //     lastTime = new Date().getTime(); //更新操作时间
    //     console.log(document.body,"lastTime111")
    // }
    function toLoginPage(){
        currentTime = new Date().getTime(); //更新当前时间
        // console.log(currentTime,"currentTime")
        // console.log(currentTime - lastTime,"------------------")
        if((currentTime - window.lastTime) > timeOut && cookie.load('login')){ //判断是否超时
                cookie.remove(LOGIN);
                cookie.remove(LEGAL_NAME);
                cookie.remove(USER_ID);
                cookie.remove("gridPageSizeParam");
                cookie.remove("gridSizeListParam");
                Modal.error({
                  title: commonLan.loginAgain,
                });
                clearInterval(window.asd);
                //超时后自动获取当前部署的siteName
                let currentHref = window.location.href;
                let splitHref = currentHref.split('/');
                let siteName = splitHref[3];
                window.location="/"+siteName+"/#/login";
        }
    }
    /* 定时器
     * 间隔15分检测是否长时间未操作页面
     */
    window.asd = setInterval(toLoginPage, 1000);
}
export default overTime
